import { generateHTML } from '@tiptap/react';
import classNames from 'classnames';
import { useMemo } from 'react';
import { extensions } from './extensions';
import styles from './TipTapText.module.scss';

type TipTapTextProps = {
  content: string;
  padding?: 'none' | 'default';
  className?: string | undefined;
};

export const TipTapText = ({ content, padding = 'default', className }: TipTapTextProps) => {
  const html = useMemo(() => {
    try {
      const json = JSON.parse(content);
      return generateHTML(json, extensions);
    } catch {
      return content;
    }
  }, [content]);

  return (
    <div className={classNames(styles['tip-tap-text'], { [styles.padding]: padding === 'default' }, className)}>
      <div className={styles.content} dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
};
